"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25],{

/***/ 25:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-lottie/dist/index.js
var dist = __webpack_require__(9464);
// EXTERNAL MODULE: ./node_modules/little-state-machine/dist/little-state-machine.es.js
var little_state_machine_es = __webpack_require__(7701);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/hooks/utils/useHasMount.js
var useHasMount = __webpack_require__(7651);
;// CONCATENATED MODULE: ./components/common/PageLoader/PageLoader.json
var PageLoader_namespaceObject = JSON.parse('{"v":"5.8.1","fr":30,"ip":0,"op":119,"w":1920,"h":1920,"nm":"ScenePlus-Icon_loader_Looped-02_4s","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Rotate - PURPLE & PINK","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.52],"y":[0.971]},"o":{"x":[0.48],"y":[0.029]},"t":40,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":53,"s":[90]},{"i":{"x":[0.52],"y":[0.926]},"o":{"x":[0.48],"y":[0.074]},"t":75,"s":[90]},{"t":88,"s":[180]}],"ix":10},"p":{"a":0,"k":[960,960,0],"ix":2,"l":2},"a":{"a":0,"k":[50,50,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ip":40,"op":120,"st":40,"bm":0},{"ddd":0,"ind":2,"ty":3,"nm":"Rotate - BLUE & RED","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.52],"y":[0.971]},"o":{"x":[0.48],"y":[0.029]},"t":40,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":53,"s":[180]},{"i":{"x":[0.52],"y":[0.963]},"o":{"x":[0.48],"y":[0.037]},"t":75,"s":[180]},{"t":88,"s":[360]}],"ix":10},"p":{"a":0,"k":[960,960,0],"ix":2,"l":2},"a":{"a":0,"k":[50,50,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ip":40,"op":120,"st":40,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Red","parent":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[584.5,50,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"d":1,"ty":"el","s":{"a":0,"k":[378,378],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.23137255013,0.282352954149,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":30,"op":119,"st":22,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Green","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,960,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"d":1,"ty":"el","s":{"a":0,"k":[378,378],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.137254908681,0.709803938866,0.454901963472,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":20,"op":109,"st":17,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Blue","parent":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-485,50,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"d":1,"ty":"el","s":{"a":0,"k":[378,378],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.172549024224,0.46274510026,0.92549020052,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":10,"op":99,"st":10,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Pink","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[585,50,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"d":1,"ty":"el","s":{"a":0,"k":[378,378],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.57647061348,0.666666686535,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":40,"op":89,"st":29,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Purple","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-485,50,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"d":1,"ty":"el","s":{"a":0,"k":[378,378],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.607843160629,0.262745112181,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":40,"op":89,"st":29,"bm":0}],"markers":[]}');
var PageLoader_PageLoader_namespaceObject = /*#__PURE__*/__webpack_require__.t(PageLoader_namespaceObject, 2);
// EXTERNAL MODULE: ./store/actions/index.js + 18 modules
var store_actions = __webpack_require__(5404);
// EXTERNAL MODULE: ./components/hooks/navigation/useRouterEvents.js
var useRouterEvents = __webpack_require__(9622);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7946);
;// CONCATENATED MODULE: ./components/common/PageLoader/PageLoaderStyles.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: rgba(0, 0, 0, 0.6);\n  margin: 0 auto;\n  height: 100%;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  z-index: 98;\n\n  p {\n    color: ",
        ";\n    font-weight: bold;\n    font-size: ",
        ";\n  }\n\n  #lottie {\n    height: 100%;\n    width: 100%;\n    max-width: 100px;\n    max-height: 100px;\n    display: block;\n    overflow: hidden;\n    transform: translate3d(0, 0, 0);\n    text-align: center;\n    opacity: 1;\n  }\n\n  @media screen and (min-width: 641px) {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  @media screen and (min-width: 768px) {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const LoaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PageLoaderStyles__LoaderWrapper",
    componentId: "app__sc-171503a2-0"
})(_templateObject(), (props)=>props.theme.whiteColor, (props)=>props.theme.headingExtraSmall);

;// CONCATENATED MODULE: ./components/common/PageLoader/PageLoader.js







// Global state

// Hooks

// Styles

function PageLoader() {
    const { actions , state: { navigation , session , labels  }  } = (0,little_state_machine_es/* useStateMachine */.j_)({
        updateNavigation: store_actions/* updateNavigation */.UI,
        updateSession: store_actions/* updateSession */.CT
    });
    const router = (0,next_router.useRouter)();
    const isMounted = (0,useHasMount/* default */.Z)();
    const defaultOptions = {
        loop: true,
        autoplay: true,
        renderer: "canvas",
        animationData: PageLoader_PageLoader_namespaceObject,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    function handleStart() {
        actions.updateNavigation({
            pageLoading: true
        });
    }
    function handleStop() {
        actions.updateNavigation({
            pageLoading: false
        });
    }
    (0,useRouterEvents/* default */.Z)({
        handleStart,
        handleStop
    });
    (0,react.useEffect)(()=>{
        if (router.asPath.includes("/register") && (session === null || session === void 0 ? void 0 : session.signInProgress)) {
            actions.updateSession({
                signInProgress: false
            });
        }
    }, [
        router
    ]);
    if (!isMounted) return null;
    if ((navigation === null || navigation === void 0 ? void 0 : navigation.pageLoading) || (session === null || session === void 0 ? void 0 : session.signInProgress)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoaderWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "lottie",
                    "data-testid": "lottie",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        options: defaultOptions
                    })
                }),
                (labels === null || labels === void 0 ? void 0 : labels.loadingLabel) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: labels === null || labels === void 0 ? void 0 : labels.loadingLabel
                })
            ]
        });
    }
    return null;
}


/***/ }),

/***/ 9622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useRouterEvents; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


function useRouterEvents(param) {
    let { handleStart , handleStop  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        router.events.on("routeChangeStart", handleStart);
        router.events.on("routeChangeComplete", handleStop);
        router.events.on("routeChangeError", handleStop);
        return ()=>{
            router.events.off("routeChangeStart", handleStart);
            router.events.off("routeChangeComplete", handleStop);
            router.events.off("routeChangeError", handleStop);
        };
    }, [
        router
    ]);
}


/***/ }),

/***/ 7651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHasMount; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useHasMount() {
    const [hasMounted, setHasMounted] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return hasMounted;
}


/***/ }),

/***/ 6165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ clearAction; }
/* harmony export */ });
/* harmony import */ var _states__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1983);

/**
 * We use this action to reset the application state back to its initial setting
 * over time we can also add conditionals inside the payload to reset specific
 * piece of state in each store object.
 *
 * over time we can control how and what store state we will clear out through a
 * switch that takes into consideration payload ex: payload.all --> clears app while payload.order --> only clears app order state
 *
 * @arg {string} payload.storeName the keyname of a particular state obj inside lsm see import for ex
 */ function clearAction(state, payload) {
    if (!payload) {
        return {
            order: _states__WEBPACK_IMPORTED_MODULE_0__/* .order */ .vm,
            points: _states__WEBPACK_IMPORTED_MODULE_0__/* .points */ .Ym,
            user: _states__WEBPACK_IMPORTED_MODULE_0__/* .user */ .EA,
            transactions: _states__WEBPACK_IMPORTED_MODULE_0__/* .transactions */ .dx,
            giftCards: _states__WEBPACK_IMPORTED_MODULE_0__/* .giftCards */ .kA,
            layout: _states__WEBPACK_IMPORTED_MODULE_0__/* .layout */ .bK,
            navigation: _states__WEBPACK_IMPORTED_MODULE_0__/* .navigation */ .G,
            notification: _states__WEBPACK_IMPORTED_MODULE_0__/* .notification */ .t6,
            offers: _states__WEBPACK_IMPORTED_MODULE_0__/* .offers */ .Y_,
            announcement: _states__WEBPACK_IMPORTED_MODULE_0__/* .announcement */ .p2,
            faq: _states__WEBPACK_IMPORTED_MODULE_0__/* .faq */ .sb,
            session: _states__WEBPACK_IMPORTED_MODULE_0__/* .session */ .nP,
            inlineMessage: _states__WEBPACK_IMPORTED_MODULE_0__/* .inlineMessage */ .Q5
        };
    }
    return {
        ...state,
        [payload.storeName]: {
            ...state[payload.storeName],
            ...payload
        }
    };
}


/***/ }),

/***/ 5404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZH": function() { return /* reexport */ clearAction/* default */.Z; },
  "mW": function() { return /* reexport */ updateAnnouncementAction; },
  "uG": function() { return /* reexport */ updateUserCustomerAction; },
  "br": function() { return /* reexport */ updateGiftCardsAction; },
  "SV": function() { return /* reexport */ updateGiftCardsRedeemAction; },
  "fi": function() { return /* reexport */ updateInlineMessage; },
  "NR": function() { return /* reexport */ updateLabelsAction; },
  "dd": function() { return /* reexport */ updateLanguageAction; },
  "fc": function() { return /* reexport */ updateLayoutAction; },
  "YF": function() { return /* reexport */ updateLocationAction; },
  "UI": function() { return /* reexport */ updateNavigationAction; },
  "wD": function() { return /* reexport */ updateNotificationAction; },
  "JV": function() { return /* reexport */ updateOffersAction; },
  "HU": function() { return /* reexport */ updateOffersFilterAction; },
  "Cs": function() { return /* reexport */ updateOrderAction; },
  "AJ": function() { return /* reexport */ updatePointsAction/* default */.Z; },
  "CT": function() { return /* reexport */ updateSessionAction; },
  "d": function() { return /* reexport */ updateStepAction/* default */.Z; },
  "Ci": function() { return /* reexport */ updateTransactionsAction; },
  "dq": function() { return /* reexport */ updateTransactionsAwardsAction; },
  "Nq": function() { return /* reexport */ updateUserAction; }
});

// EXTERNAL MODULE: ./store/actions/updatePointsAction.js
var updatePointsAction = __webpack_require__(6348);
;// CONCATENATED MODULE: ./store/actions/updateTransactionsAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload { cards: [...], selectedCard: {...}, balance: <Number>,}
 * @returns
 */ function updateTransactionsAction(state, payload) {
    return {
        ...state,
        transactions: {
            ...state.transactions,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateTransactionsAwardsAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload { cards: [...], selectedCard: {...}, balance: <Number>,}
 * @returns
 */ function updateTransactionsAwardsAction(state, payload) {
    return {
        ...state,
        transactions: {
            ...state.transactions,
            awards: {
                ...state.awards,
                ...payload
            }
        }
    };
}

// EXTERNAL MODULE: ./store/actions/updateStepAction.js
var updateStepAction = __webpack_require__(9782);
;// CONCATENATED MODULE: ./store/actions/updateUserAction.js
function updateUserAction(state, payload) {
    return {
        ...state,
        user: {
            ...state.user,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateOrderAction.js
function updateOrderAction(state, payload) {
    return {
        ...state,
        order: {
            ...state.order,
            ...payload
        }
    };
}

// EXTERNAL MODULE: ./store/actions/clearAction.js
var clearAction = __webpack_require__(6165);
;// CONCATENATED MODULE: ./store/actions/updateUserCustomerAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload { k:v }
 * @returns
 */ function updateUserCustomerAction(state, payload) {
    return {
        ...state,
        user: {
            ...state.user,
            customer: {
                ...state.customer,
                ...payload
            }
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateGiftCardsAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateGiftCardsAction(state, payload) {
    return {
        ...state,
        giftCards: {
            ...state.giftCards,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateGiftCardsRedeemAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload nested redeem object inside gift cards
 * @returns
 */ function updateGiftCardsRedeemAction(state, payload) {
    return {
        ...state,
        giftCards: {
            ...state.giftCards,
            redeem: {
                ...state.giftCards.redeem,
                ...payload
            }
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateNotificationAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateNotificationAction(state, payload) {
    return {
        ...state,
        notification: {
            ...state.message,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateOffersAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateOffersAction(state, payload) {
    return {
        ...state,
        offers: {
            ...state.offers,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateLayoutAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateLayoutAction(state, payload) {
    return {
        ...state,
        layout: {
            ...state.layout,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateAnnouncementAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateAnnouncementAction(state, payload) {
    return {
        ...state,
        announcements: {
            ...state.announcements,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateNavigationAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateNavigationAction(state, payload) {
    return {
        ...state,
        navigation: {
            ...state.navigation,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateLabelsAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateLabelsAction(state, payload) {
    return {
        ...state,
        labels: {
            ...state.labels,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateSessionAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateSessionAction(state, payload) {
    return {
        ...state,
        session: {
            ...state.session,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateLanguageCodeAction.js
function updateLanguageAction(state, payload) {
    // console.log('state:', state.language);
    // console.log('payload:', payload);
    return {
        ...state,
        language: {
            ...state.language,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateLocationAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateLocationAction(state, payload) {
    return {
        ...state,
        location: {
            ...state.location,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateOffersFilterAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateOffersFilterAction(state, payload) {
    return {
        ...state,
        offers: {
            ...state.offers,
            filter: {
                ...state.offers.filter,
                ...payload
            }
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/updateInlineMessageAction.js
/**
 *
 * @param {*} state existing state
 * @param {*object} payload
 * @returns
 */ function updateInlineMessage(state, payload) {
    return {
        ...state,
        inlineMessage: {
            ...state.inlineMessage,
            ...payload
        }
    };
}

;// CONCATENATED MODULE: ./store/actions/index.js























/***/ }),

/***/ 6348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ updatePoints; }
/* harmony export */ });
function updatePoints(state, payload) {
    return {
        ...state,
        points: {
            ...state.points,
            ...payload
        }
    };
}


/***/ }),

/***/ 9782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ updateStep; }
/* harmony export */ });
function updateStep(state, payload) {
    return {
        ...state,
        user: {
            ...state.user,
            ...payload
        }
    };
}


/***/ })

}]);